// extracted by mini-css-extract-plugin
module.exports = {"no-file-message":"FileUploadComponent_no-file-message__2LvIN","webcam-container":"FileUploadComponent_webcam-container__10PJe"};